import { Component, OnInit } from '@angular/core';
import { seeds } from '../../seeds/seeds';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormGroup, FormControl, FormArray, Validators  } from '@angular/forms';
import { HaulersService } from '../haulers.service';
import { Response } from '@angular/http/src/static_response';
import { Hauler } from '../hauler.model';
import { GeoService } from '../../shared/geo.service';


@Component({
  selector: 'app-haulers-edit',
  templateUrl: './haulers-edit.component.html',
  styleUrls: ['./haulers-edit.component.css']
})
export class HaulersEditComponent implements OnInit {
  id: string;
  wasteTypes = seeds.wasteTypes;
  editMode = false;
  haulerForm: FormGroup;
  hauler: Hauler;
  wastes: Array<String>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private haulersService: HaulersService,
    private geoService: GeoService
  ) { }

  ngOnInit() {
    this.route.params
      .subscribe(
        (params: Params) => {
          this.id = params['id'];
          this.editMode = params['id'] != null;
          this.initForm();
        }
      );
  }

  onSubmit() {
    if (this.editMode) {
      console.log(this.haulerForm.value['wastes']);
      const newHauler: Hauler = this.haulerForm.value;

      newHauler['_id'] = this.id;


      // Geocoding Address
      const location = newHauler.address + String(newHauler.postcode);
      this.geoService.getLocation(location)
      .then((response) => {
          newHauler.lat = response.results[0].geometry.location.lat;
          newHauler.lng = response.results[0].geometry.location.lng;
          this.haulersService.updateItem(this.id, newHauler);
      });

    } else {
      const newHauler: Hauler = this.haulerForm.value;

      // Geocoding Address
      this.geoService.getLocation(newHauler.address)
      .then((response) => {
          newHauler.lat = response.results[0].geometry.location.lat;
          newHauler.lng = response.results[0].geometry.location.lng;
          this.haulersService.addItem(newHauler);
      });

    }
    this.onCancel();
  }

  onCancel() {
    this.router.navigate(['/haulers/map'], {relativeTo: this.route});
  }

  onDeleteHauler() {
    this.haulersService.removeItem(this.id);
    this.router.navigate(['/haulers/map']);
  }

  private initForm() {

    let haulerName = '';
    let haulerAddress = '';
    let haulerSiret = '';
    let haulerPostcode ;
    let haulerServices = {'collect': true, 'treatment': true};
    let haulerWastes: string[] = [];
    let haulerEmail = '';
    let haulerPhone = '';

    if (this.editMode) {
        this.haulersService.getItem(this.id).subscribe( hauler => {
          haulerName = hauler['name'] ;
          haulerSiret = hauler['siret'];
          haulerAddress = hauler['address'];
          haulerPostcode = hauler['postcode'];
          haulerServices = hauler['services'];
          haulerWastes = hauler['wastes'];
          haulerEmail = hauler['email'];
          haulerPhone = hauler['phone'];


          this.haulerForm = new FormGroup({
            'name': new FormControl(haulerName, Validators.required),
            'siret': new FormControl(haulerSiret, Validators.pattern(/^([0-9]{3}){3}[0-9]{4}$/)),
            'address': new FormControl(haulerAddress, Validators.required),
            'postcode': new FormControl(haulerPostcode, [Validators.required, Validators.pattern(/^[0-9]{5}$/)]),
            'services': new FormGroup(
              {
                'collect' : new FormControl(haulerServices.collect),
                'treatment' : new FormControl(haulerServices.treatment)
              },
              Validators.required),
            'wastes': new FormControl(haulerWastes),
            'email': new FormControl(haulerEmail, [Validators.required, Validators.email]),
            'phone': new FormControl(haulerPhone, Validators.required),
          });


        });

    }

    this.haulerForm = new FormGroup({
      'name': new FormControl(haulerName, Validators.required),
      'siret': new FormControl(haulerSiret, Validators.pattern(/^([0-9]{3}){3}[0-9]{4}$/)),
      'address': new FormControl(haulerAddress, Validators.required),
      'postcode': new FormControl(haulerPostcode, [Validators.required, Validators.pattern(/^[0-9]{5}$/)]),
      'services': new FormGroup(
        {
          'collect' : new FormControl(haulerServices.collect),
          'treatment' : new FormControl(haulerServices.treatment)
        },
        Validators.required),
      'wastes': new FormControl(haulerWastes),
      'email': new FormControl(haulerEmail, [Validators.required, Validators.email]),
      'phone': new FormControl(haulerPhone, Validators.required),
    });
  }

}



// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/haulers/haulers-edit/haulers-edit.component.ts